const whBaseData = {
  assessItem: '考核项目',
  category: '分类',
  categoryType: '类别',
  subCategory: '子类别',
  versionNo: '版本号',
  isEffective: '是否生效',
  briefDesc: '简要描述',
  assessContent: '考核内容',
  citationBasis: '援引依据',
  score: '分值',
  breachExample: '违约示例描述',
  msg: {}
};
export default whBaseData;



// WEBPACK FOOTER //
// ./src/page/assess/whBaseData/lang/whBaseData.zh.js